import { createFileRoute } from '@tanstack/react-router'

import GuestOrderDetailPage from '@/views/orders/pages/guest.orders-detail.page'

export const Route = createFileRoute('/_layout/guest/orders/$id')({
  component: GuestOrderDetailPage,
})
